// extracted by mini-css-extract-plugin
export default {"row":"styles_row__YI7kb","icone":"styles_icone__oTWOU"};